module.exports = __webpack_public_path__ + "gamecode/img/dtmslgjk_favicon.png?523c1cea";